import React from 'react'
import Product from './Components/Product'
import classes from './css/Shop.module.css'
import { useContext } from 'react'
import CartContext from '../store/CartContext'



const Shop = () => {
    const cartCtx = useContext(CartContext);
    const addToCartHandler = (amount)=>{
        cartCtx.addItem({
            id:Product.id,
            amount:amount,
        });
    }
    return (
        <div className={classes.shop}>
            
        <div className={classes.shopContainerShadow}>
            
            <h1 className={classes.featuredProducts}>Featured Products</h1>
            <div className={classes.shopContainer}>
                <br /><br /><br />
                <div className={classes.productsGrid}>
                    <Product
                        onAddToCart={addToCartHandler}
                        id={1}
                        key={1}
                        color={'orange'}
                        pillImg={'trump'}
                        title={['SUPER' , <br/> ,' TRUMP']}
                        content={80}
                        rating={4}
                        priceBTC={0.0021}
                        priceETH={0.0802}
                    />
                    <Product
                        id={2}
                        key={2}
                        color={'blue'}
                        pillImg={'tesla'}
                        title={'Tesla'}
                        content={100}
                        rating={5}
                        priceBTC={0.0023}
                        priceETH={0.0832}
                    />
                    <Product
                    
                        id={3}
                        key={3}
                        color={'blue'}
                        pillImg={'bluePill'}
                        title={'BLUE CLOVER'}
                        content={80}
                        rating={4}
                        priceBTC={0.0021}
                        priceETH={0.0802}
                    />
                    <Product
                        
                        id={4}
                        key={4}
                        color={'green'}
                        pillImg={'green'}
                        title={['GREEN' , <br/> ,'SNOWFLAKE']}
                        content={120}
                        rating={4}
                        priceBTC={0.0021}
                        priceETH={0.0802}
                    />
                </div>
            </div>
            
        </div>
        <p className={classes.footerText}>A Fan recreation of <a href="http://mydrugs.to" target="_blank">MyDrugs.to</a> (Netflix Series). Does not actually sell neither legal or illegal substances. <br/> Made by elMidori | <a href="#" target="_blank">Portfolio</a>  &copy; Copyright 2021.</p>
    
        </div>

    )
}

export default Shop
